@if (isUserLoggedin()) {
  @let hunter = planthunter();
  @if (hunter && !show404()) {
    <section class="cms-header cms-header--planthunter"
      [style.background-image]="'url(' + hunter.bannerUrl + ')'">
      <div class="row">
        <div class="col-12">
          <div class="cms-header__inner">
          </div>
        </div>
      </div>
    </section>
  }
  <div class="row">
    <div class="col-12 col-sm-12">
      <section>
        <div class="cms-article__back-link">
          <a (click)="gotoHunterOverview()">
            <svg class="icon-arrow-left" width="6" height="10">
              <use xmlns:xlink="http://www.w3.org/1999/xlink"
              xlink:href="/images/icons/svg-sprite.svg#arrow-left"></use>
            </svg>
            <ng-container i18n="Back to planthunters overview link text@@planthunter.back.to.overview">
								Back to overview
							</ng-container>
          </a>
        </div>
        @if (hunter && !show404()) {
          <div class="planthunter__header">
            <div class="planthunter__hunter planthunter__hunter--detail">
              <figure class="planthunter__hunter__figure">
                <img src="{{hunter.imageUrl}}" alt="{{hunter.name}}" />
              </figure>
              <div class="planthunter__hunter__text">
                <h2 class="planthunter__hunter__name">
                  {{hunter.name}}
                </h2>
                <p class="planthunter__hunter__function">{{hunter.functionDescription}}</p>
                @if (!hunter.volgStatus) {
                  <p class="planthunter__hunter__follow hide-lg">
                    <button (click)="followPlanthunter()"
                      class="button button--small button--secondary button--text"
                      i18n="Planthunters start following@@planthunter.start.following">
									Follow {{hunter.firstName}}
								</button>
                  </p>
                }
                @if (hunter.volgStatus) {
                  <p class="planthunter__hunter__follow hide-lg">
                    <button class="button button--small button--green" (click)="unfollowPlanthunter()">
                      <ng-container i18n="Planthunter following link@@planthunter.following.link">
										Following
									</ng-container>
                      &nbsp;
                      <svg class="icon-check" width="14" height="12">
                        <use xlink:href="/images/icons/svg-sprite.svg#check"></use>
                      </svg>
                    </button>
                  </p>
                }
                <div class="planthunter__hunter__description hide-sm">
                  <div [innerHTML]="hunter.description"></div>
                  <div class="planthunter__hunter__summary">
                    <span>
                      <svg class="icon-search" width="16" height="16">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="/images/icons/svg-sprite.svg#search"></use>
                      </svg>
                      <ng-container i18n="Planthunter hunts amount@@planthunter.hunts.amount">
											{{hunter.huntCount}} hunts
										</ng-container>
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <span>
                      <svg class="icon-user" width="16" height="19"
                        style="vertical-align: text-top;">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                        xlink:href="/images/icons/svg-sprite.svg#user"></use>
                      </svg>
                      <ng-container i18n="Planthunter followers amount@@planthunter.followers.amount">
											{{hunter.followerCount}} followers
										</ng-container>
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <span>
                      <img src="/template/assets/images/icon-speechbubble.svg"
                        style="vertical-align: text-top; display: inline-block; margin-right: 2px;"
                        width="16" height="16" alt="" />
                      <a href="mailto:{{hunter.email}}" style="text-decoration: underline;"
                        i18n="Planthunter contact@@planthunter.contact">
											Contact {{hunter.firstName}}
										</a>
                    </span>
                  </div>
                </div>
              </div>
              @if (!hunter.volgStatus) {
                <div class="planthunter__hunter__follow hide-sm">
                  <button (click)="followPlanthunter()"
                    class="button button--small button--secondary button--text"
                    i18n="Planthunters start following@@planthunter.start.following">
								Follow {{hunter.firstName}}
							</button>
                </div>
              }
              @if (hunter.volgStatus) {
                <div class="planthunter__hunter__follow hide-sm">
                  <button (click)="unfollowPlanthunter()"
                    class="button button--small button--green">
                    <ng-container i18n="Planthunter following link@@planthunter.following.link">
									Following
								</ng-container>
                    &nbsp;
                    <svg class="icon-check" width="14" height="12">
                      <use xlink:href="/images/icons/svg-sprite.svg#check"></use>
                    </svg>
                  </button>
                </div>
              }
            </div>
            <div class="planthunter__hunter__description hide-lg">
              <div [innerHTML]="hunter.description"></div>
              <div class="planthunter__hunter__summary">
                <span>
                  <svg class="icon-search" width="16" height="16">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="/images/icons/svg-sprite.svg#search"></use>
                  </svg>
                  <ng-container i18n="Planthunter hunts amount@@planthunter.hunts.amount">
									{{hunter.huntCount}} hunts
								</ng-container>
                </span>
                <span>
                  <svg class="icon-user" width="16" height="19"
                    style="vertical-align: text-top;">
                    <use xmlns:xlink="http://www.w3.org/1999/xlink"
                    xlink:href="/images/icons/svg-sprite.svg#user"></use>
                  </svg>
                  <ng-container i18n="Planthunter followers amount@@planthunter.followers.amount">
									{{hunter.followerCount}} followers
								</ng-container>
                </span>
                <span>
                  <img src="/template/assets/images/icon-speechbubble.svg"
                    style="vertical-align: text-top; display: inline-block; margin-right: 2px;"
                    width="16" height="16" alt="" />
                  <a href="mailto:{{hunter.email}}" style="text-decoration: underline;"
                    i18n="Planthunter contact@@planthunter.contact">
									Contact {{hunter.firstName}}
								</a>
                </span>
              </div>
            </div>
          </div>
        }
      </section>
      @if (hunter && !show404()) {
        <section class="planthunter-detail-products">
          <h2 i18n="Planthunters latest hunts@@planthunter.latest.hunts">
					{{hunter.firstName}}'s latest hunts:
				</h2>
          <div class="planthunter__products">
            <div class="overview-grid overview-grid--planthunter">
              @for (product of hunter.products; track product) {
                <product-item-grid #productItemGridComponent
                  (lazyLoad)="productItemGridComponent.doLoad($event)"
                  (viewProductDetailClickEvent)="viewProductDetail($event)"
                  [loggedIn]="isUserLoggedin()"
                  [product]="product"
                  class="overview-product">
                </product-item-grid>
              }
            </div>
          </div>
        </section>
      }
      @if (show404()) {
        <notfound></notfound>
      }
    </div>
  </div>
}
